import { TIcons } from '../type/icons-type';
import { PAGE_ROUTES } from '../constants/pageRoutes';

export interface IMenuRouteMetadata {
	path?: string | null;
	icon: TIcons;
	text?: string;
	subMenu?: Record<string, any> | null;
}

// CANONICAL ROUTE AND ICON CONFIGURATION FOR SYSTEM PERMISSIONS
export const MENU_ROUTE_CONFIG: Record<string, IMenuRouteMetadata> = {
	dashboard: {
		path: PAGE_ROUTES.DASHBOARD,
		icon: 'Dashboard',
		text: 'Dashboard',
		subMenu: null,
	},
	profile: {
		path: PAGE_ROUTES.PROFILE,
		icon: 'Person',
		text: 'Profile',
		subMenu: null,
	},
	company: {
		path: PAGE_ROUTES.GENERAL_SETTING,
		icon: 'Settings',
		text: 'General Setting',
		subMenu: null,
	},

	// USER MANAGEMENT
	user_management: {
		path: null,
		icon: 'ManageAccounts',
		text: 'User Management',
		subMenu: null,
	},
	users: {
		path: PAGE_ROUTES.USERS,
		icon: 'Group',
		text: 'Users',
		subMenu: null,
	},
	roles: {
		path: PAGE_ROUTES.ROLES,
		icon: 'AdminPanelSettings',
		text: 'Roles',
		subMenu: null,
	},
	login_history: {
		path: PAGE_ROUTES.LOGIN_HISTORY,
		icon: 'History',
		text: 'Login History',
		subMenu: null,
	},

	// MASTER PARENT
	masters: {
		path: null,
		icon: 'Folder',
		text: 'Master',
		subMenu: null,
	},

	// MASTER SUBMENU ITEMS
	item: {
		path: PAGE_ROUTES.ITEMS,
		icon: 'Style',
		text: 'Item',
		subMenu: null,
	},
	item_type: {
		path: PAGE_ROUTES.ITEM_TYPES,
		icon: 'Category',
		text: 'Item Type',
		subMenu: null,
	},
	size: {
		path: PAGE_ROUTES.SIZES,
		icon: 'Straighten',
		text: 'Size',
		subMenu: null,
	},
	colour: {
		path: PAGE_ROUTES.COLOURS,
		icon: 'Palette',
		text: 'Colour',
		subMenu: null,
	},
	process: {
		path: PAGE_ROUTES.PROCESSES,
		icon: 'AccountTree',
		text: 'Process',
		subMenu: null,
	},
	fabric: {
		path: PAGE_ROUTES.FABRICS,
		icon: 'BlurOn',
		text: 'Fabric',
		subMenu: null,
	},
	fabric_type: {
		path: PAGE_ROUTES.FABRIC_TYPES,
		icon: 'Texture',
		text: 'Fabric Type',
		subMenu: null,
	},
	fabric_stage: {
		path: PAGE_ROUTES.FABRIC_STAGES,
		icon: 'Timeline',
		text: 'Fabric Stage',
		subMenu: null,
	},
	expense_category: {
		path: PAGE_ROUTES.EXPENSE_CATEGORIES,
		icon: 'Category',
		text: 'Expense Category',
		subMenu: null,
	},
	tax_rate: {
		path: PAGE_ROUTES.TAX_RATES,
		icon: 'ReceiptLong',
		text: 'Tax Rates',
		subMenu: null,
	},
	party: {
		path: PAGE_ROUTES.PARTIES,
		icon: 'People',
		text: 'Party',
		subMenu: null,
	},
	cutting_component: {
		path: PAGE_ROUTES.CUTTING_COMPONENTS,
		icon: 'ContentCut',
		text: 'Cutting Component',
		subMenu: null,
	},
	labour: {
		path: PAGE_ROUTES.LABOURS,
		icon: 'Engineering',
		text: 'Labour',
		subMenu: null,
	},

	// PRODUCTION PARENT
	production: {
		path: null,
		icon: 'PrecisionManufacturing',
		text: 'Production',
		subMenu: null,
	},

	// PRODUCTION SUBMENU ITEMS
	fabric_inward: {
		path: PAGE_ROUTES.FABRIC_INWARDS,
		icon: 'Input',
		text: 'Fabric Inward',
		subMenu: null,
	},
	fabric_stock: {
		path: PAGE_ROUTES.FABRIC_STOCK,
		icon: 'Inventory2',
		text: 'Fabric Stock',
		subMenu: null,
	},
	cutting: {
		path: PAGE_ROUTES.CUTTING,
		icon: 'ContentCut',
		text: 'Cutting',
		subMenu: null,
	},
	cutting_stock: {
		path: PAGE_ROUTES.CUTTING_STOCK,
		icon: 'Inventory',
		text: 'Cutting Stock',
		subMenu: null,
	},
	bundling: {
		path: PAGE_ROUTES.BUNDLING,
		icon: 'QrCode2',
		text: 'Bundling',
		subMenu: null,
	},
	bundle_stock: {
		path: PAGE_ROUTES.BUNDLE_STOCK,
		icon: 'Inventory',
		text: 'Bundle Stock',
		subMenu: null,
	},
	process_issue: {
		path: null,
		icon: 'AssignmentReturn',
		text: 'Process Issue',
		subMenu: null,
	},
	process_receive: {
		path: null,
		icon: 'AccountTree',
		text: 'Process Receive',
		subMenu: null,
	},
	process_flow: {
		path: PAGE_ROUTES.PROCESS_FLOW,
		icon: 'AccountTree',
		text: 'All Process Flow',
		subMenu: null,
	},
	ready_stock: {
		path: PAGE_ROUTES.READY_STOCK,
		icon: 'Inventory2',
		text: 'Ready Stock',
		subMenu: null,
	},
	labour_hisaab: {
		path: PAGE_ROUTES.LABOUR_HISAAB,
		icon: 'AccountBalanceWallet',
		text: 'Labour Hisaab',
		subMenu: null,
	},
	labour_hisaab_piece_rate: {
		path: PAGE_ROUTES.LABOUR_HISAAB,
		icon: 'Payments',
		text: 'Piece Rate Wages',
		subMenu: null,
	},
	labour_hisaab_monthly_salary: {
		path: PAGE_ROUTES.LABOUR_HISAAB_MONTHLY_SALARY,
		icon: 'AccountBalanceWallet',
		text: 'Monthly Salary',
		subMenu: null,
	},
	delivery_challan: {
		path: PAGE_ROUTES.DELIVERY_CHALLAN,
		icon: 'LocalShipping',
		text: 'Delivery Challan',
		subMenu: null,
	},

	sales: {
		path: null,
		icon: 'PointOfSale',
		text: 'Sales',
		subMenu: null,
	},
	// sales_order: {
	// 	path: PAGE_ROUTES.SALES_ORDER,
	// 	icon: 'Receipt',
	// 	text: 'Sales Order',
	// 	subMenu: null,
	// },
	sales_invoice: {
		path: PAGE_ROUTES.SALES_INVOICE,
		icon: 'RequestQuote',
		text: 'Sales Invoice',
		subMenu: null,
	},
	customer_payment: {
		path: PAGE_ROUTES.CUSTOMER_PAYMENT,
		icon: 'Payments',
		text: 'Customer Payment',
		subMenu: null,
	},
	credit_note: {
		path: PAGE_ROUTES.CREDIT_NOTE,
		icon: 'AssignmentReturn',
		text: 'Credit Note',
		subMenu: null,
	},
	purchase: {
		path: null,
		icon: 'LocalShipping',
		text: 'Purchase',
		subMenu: null,
	},
	// purchase_order: {
	// 	path: PAGE_ROUTES.PURCHASE_ORDER,
	// 	icon: 'Receipt',
	// 	text: 'Purchase Order',
	// 	subMenu: null,
	// },
	purchase_invoice: {
		path: PAGE_ROUTES.PURCHASE_INVOICE,
		icon: 'RequestQuote',
		text: 'Purchase Invoice',
		subMenu: null,
	},
	supplier_payment: {
		path: PAGE_ROUTES.SUPPLIER_PAYMENT,
		icon: 'Payments',
		text: 'Supplier Payment',
		subMenu: null,
	},
	debit_note: {
		path: PAGE_ROUTES.DEBIT_NOTE,
		icon: 'AssignmentReturn',
		text: 'Debit Note',
		subMenu: null,
	},
	finance: {
		path: null,
		icon: 'Payments',
		text: 'Finance',
		subMenu: null,
	},
	expenses: {
		path: PAGE_ROUTES.EXPENSES,
		icon: 'Receipt',
		text: 'Expenses',
		subMenu: null,
	},
	petty_cash: {
		path: PAGE_ROUTES.PETTY_CASH,
		icon: 'PointOfSale',
		text: 'Petty Cash',
		subMenu: null,
	},
	bank: {
		path: PAGE_ROUTES.BANK,
		icon: 'RequestQuote',
		text: 'Bank',
		subMenu: null,
	},

	// REPORTS
	reports: {
		path: PAGE_ROUTES.REPORTS,
		icon: 'Assessment',
		text: 'Reports',
		subMenu: null,
	},
	reports_dashboard: {
		path: PAGE_ROUTES.REPORTS_DASHBOARD,
		icon: 'DashboardCustomize',
		text: 'Reports Dashboard',
		subMenu: null,
	},
	report_production_summary: {
		path: 'reports/production_summary',
		icon: 'Summarize',
		text: 'Production Summary',
		subMenu: null,
	},
	report_fabric_stock: {
		path: 'reports/fabric_stock',
		icon: 'Inventory',
		text: 'Fabric Stock Report',
		subMenu: null,
	},
	report_cutting: {
		path: 'reports/cutting',
		icon: 'ContentCut',
		text: 'Cutting Report',
		subMenu: null,
	},
	report_cutting_variance: {
		path: 'reports/cutting_variance',
		icon: 'CompareArrows',
		text: 'Cutting Variance Report',
		subMenu: null,
	},
	report_cutting_stock: {
		path: 'reports/cutting_stock',
		icon: 'Inventory2',
		text: 'Cutting Stock Report',
		subMenu: null,
	},
	report_bundle_tracking: {
		path: 'reports/bundle_tracking',
		icon: 'AccountTree',
		text: 'Bundle Tracking Report',
		subMenu: null,
	},
	report_process_pending: {
		path: 'reports/process_pending',
		icon: 'PendingActions',
		text: 'Process Pending Report',
		subMenu: null,
	},
	report_ready_stock: {
		path: 'reports/ready_stock',
		icon: 'Checkroom',
		text: 'Ready Stock Report',
		subMenu: null,
	},
	report_dispatch: {
		path: 'reports/dispatch',
		icon: 'LocalShipping',
		text: 'Delivery / Dispatch Report',
		subMenu: null,
	},
	report_lot_trace: {
		path: 'reports/lot_trace',
		icon: 'Timeline',
		text: 'Lot Traceability Report',
		subMenu: null,
	},
	report_labour_payment: {
		path: null,
		icon: 'Payments',
		text: 'Labour Payment Report',
		subMenu: null,
	},
	report_labour_payment_piece_rate: {
		path: 'reports/labour_payment?pay_basis=PIECE_RATE',
		icon: 'Payments',
		text: 'Piece Rate Wages Report',
		subMenu: null,
	},
	report_labour_payment_monthly_salary: {
		path: 'reports/labour_payment/monthly-salary',
		icon: 'AccountBalanceWallet',
		text: 'Monthly Salary Report',
		subMenu: null,
	},
};

// RESOLVE ROUTE METADATA FOR A GIVEN PERMISSION KEY OR NAME DYNAMICALLY
export const getMenuMetadataForPermission = (
	permissionKey: string,
	fallbackName: string,
): IMenuRouteMetadata | null => {
	const normalizeStr = (str: string) =>
		(str || '')
			.toLowerCase()
			.trim()
			.replace(/[-_\s]+/g, '_');

	const keyNorm = normalizeStr(permissionKey);
	const nameNorm = normalizeStr(fallbackName);

	const candidates = [
		keyNorm,
		nameNorm,
		keyNorm.endsWith('s') ? keyNorm.slice(0, -1) : `${keyNorm}s`,
		nameNorm.endsWith('s') ? nameNorm.slice(0, -1) : `${nameNorm}s`,
		// Handle American/British English spelling (color / colour)
		keyNorm.replace('color', 'colour'),
		nameNorm.replace('color', 'colour'),
	];

	for (const candidate of candidates) {
		if (candidate && MENU_ROUTE_CONFIG[candidate]) {
			return {
				...MENU_ROUTE_CONFIG[candidate],
				text: MENU_ROUTE_CONFIG[candidate].text || fallbackName,
			};
		}
	}

	return null;
};
